import script from "./Drink.vue?vue&type=script&setup=true&lang=js"
export * from "./Drink.vue?vue&type=script&setup=true&lang=js"

import "./Drink.vue?vue&type=style&index=0&id=632ab1e9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-632ab1e9"]])

export default __exports__